import { render, staticRenderFns } from "./shop-list.vue?vue&type=template&id=67ac9257&scoped=true"
import script from "./shop-list.vue?vue&type=script&lang=ts"
export * from "./shop-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ac9257",
  null
  
)

export default component.exports